import { ReactElement } from 'react'
import { Error as MuiError } from '@mui/icons-material'
import { Button } from 'src/ui-components'
import styled from 'styled-components'
import { defaultTheme } from 'src/theme'
import { I18n } from 'common'

interface Props {
  showContactUs: boolean
}

export const UnableToConnect = ({ showContactUs }: Props): ReactElement => {
  return (
    <Container>
      <MuiError
        style={{
          color: defaultTheme.colors.red,
        }}
        sx={{
          width: '72px',
          height: '72px',
          marginTop: '50px',
        }}
      />
      <Header>
        <I18n
          name="oopsSomethingWentWrong"
          style={{ textTransform: 'uppercase' }}
        />
      </Header>

      <I18n
        name="weWereUnableToProcessYourRequest"
        style={{ marginBottom: '15px' }}
      />

      <ButtonWrapper>
        {showContactUs ?? <Button variant="secondary" text="contactUs" />}

        <Button variant="primary" text="tryAgain" />
      </ButtonWrapper>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: white;
`

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
`

const Header = styled.div`
  font-size: 24px;
  font-family: Oswald, serif;
  font-weight: bold;
  margin: 15px;
`
